module.exports = __webpack_public_path__ + "static/media/laurempicsum.63ea5b09.jpg";